<template>
  <wireframe-wrapper>
    <!-- top menu -->
    <app-bar
      v-if="$scopedSlots.bar && $route.name !== 'upload' && (!isMobileNavigation || hasMobileViewerChrome)"
      :color="bar.color"
      :dark="bar.dark || dark"
      :dense="bar.dense"
      :height="bar.height"
      :class="{
        'viewer-mobile-app-bar': isMobileNavigation && hasMobileViewerChrome
      }"
      :left="false"
      :mobile-breakpoint="topBarMobileBreakpoint"
      :mobile-menu-component="bar.mobileMenuComponent"
      :mobile-menu-visible="mobileMenuVisible"
      @toggle-mobile-menu="mobileMenuVisible = !mobileMenuVisible"
    >
      <template v-slot="data"><slot name="bar" v-bind="data"/></template>
    </app-bar>

    <!-- mobile top menu -->
    <mobile-top-menu
      v-if="$route.name !== 'upload'"
      :dark="bar.dark || dark"
      :mobile-breakpoint="topBarMobileBreakpoint"
      :steteless="bar.stateless"
      v-model="mobileMenuVisible"
    >
      <template v-slot="data"><slot name="bar" v-bind="data"/></template>
    </mobile-top-menu>

    <!-- left navigation drawer -->
    <app-navigation
      v-if="$scopedSlots.navLeft && $route.name !== 'upload' && !isMobileNavigation"
      :clipped="false"
      :color="dark ? '' : navLeft.color"
      :collapsable="false"
      :dark="navLeft.dark || dark"
      mini-variant
      :mini-variant-width="navLeft.width"
      :mobile-breakpoint="leftNavMobileBreakpoint"
      :width="navLeft.width"
      v-model="navLeftVisible"
    >
      <template v-slot="data"><slot name="navLeft" v-bind="data"/></template>
    </app-navigation>

    <!-- right navigation drawer -->
    <app-navigation
      v-if="$scopedSlots.navRight && $route.name !== 'upload'"
      :clipped="true"
      :color="navRight.color"
      :collapsable="navRight.collapsable"
      :dark="navRight.dark || dark"
      :mobile-breakpoint="mobileBreakpoint"
      :right="true"
      :width="navRight.width"
      v-model="navRightVisible"
    >
      <template v-slot="data"><slot name="navRight" v-bind="data"/></template>
    </app-navigation>

    <!-- Sizes your content based upon application components -->
    <v-main class="h-100">
      <v-container
        class="d-flex justify-end pa-0"
        fluid
        :style="{ height: '100%' }"
      >
        <app-navigation
          v-if="$scopedSlots.nav"
          absolute
          :dark="nav.dark || dark"
          :app="false"
          :color="nav.color"
          :collapsable="nav.collapsable"
          :width="nav.width"
          v-model="navVisible"
        >
          <template v-slot="data">
            <slot name="nav" v-bind="data" />
          </template>
        </app-navigation>

        <!-- default slot -->
        <div
          :style="
            $scopedSlots.nav && !$vuetify.breakpoint[mobileBreakpoint]
              ? { width: `calc(100% - ${navVisible ? nav.width : 0}px)` }
              : { width: '100%' }
          "
        >
          <slot />
        </div>
      </v-container>
    </v-main>

    <v-footer
      v-if="$scopedSlots.footer"
      app
      :dark="footer.dark || dark"
      :height="footer.height"
      inset
    >
      <slot name="footer" />
    </v-footer>

    <!-- togglers -->
    <template
      v-if="$scopedSlots.nav && !navVisible"
      v-slot:navigation-drawer-toggler-inner
    >
      <navigation-toggler
        :style="{ ...navTogglerStyle, left: `${$vuetify.application.left}px` }"
        @toggle="navVisible = !navVisible"
      />
    </template>

    <template
      v-if="$scopedSlots.navRight && !navRightVisible"
      v-slot:navigation-drawer-toggler-right
    >
      <navigation-toggler
        right
        :class="{ 'mobile-navigation-drawer-toggler': isMobileNavigation }"
        :style="navTogglerStyle"
        @toggle="navRightVisible = !navRightVisible"
      />
    </template>
  </wireframe-wrapper>
</template>

<script>
import Common from "./common/mixin";
import { isPortraitMobile } from "@/js/utils.responsive";

const AppBar = () => import("./common/Bar");
const AppNavigation = () => import("./common/Navigation");
const MobileTopMenu = () => import("./common/MobileTopMenu");
const NavigationToggler = () => import("./common/NavigationToggler");

export default {
  name: "BasicWireframe",
  mixins: [Common],
  components: { AppBar, AppNavigation, MobileTopMenu, NavigationToggler },
  props: {
    nav: { default: () => ({}), type: Object },
    dark: { default: false, type: Boolean }
  },
  computed: {
    isMobileNavigation() {
      return isPortraitMobile(this.$vuetify.breakpoint);
    },
    hasMobileViewerChrome() {
      return this.$route.matched.some(
        route => route.meta && route.meta.mobileViewerChrome
      );
    },
    topBarMobileBreakpoint() {
      return this.forceCompactNavLeft ? 0 : this.mobileBreakpoint;
    },
    leftNavMobileBreakpoint() {
      return this.forceCompactNavLeft ? 0 : this.mobileBreakpoint;
    }
  },
  data() {
    return {
      navVisible: !this.$vuetify.breakpoint[this.mobileBreakpoint]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "./common/style.scss";

.viewer-mobile-app-bar {
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
}

.viewer-mobile-app-bar::-webkit-scrollbar {
  display: none;
}

.mobile-navigation-drawer-toggler.right {
  contain: paint;
}
</style>
